import React from "react";

const Header = () => {
  return (
    <header>
      <h1>Andrew Browne's Portfolio</h1>
      <nav>
        <a href="#projects">Projects</a>
        <a href="#science">Scientific Work</a>
      </nav>
    </header>
  );
};

export default Header;
